var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 7L10 13L16 7","stroke":"#344054","stroke-width":"1.67","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }